var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contract-summary-document"},[_vm._v(" Die Vertragszusammenfassung finden Sie "),_c('span',{staticClass:"link",on:{"click":_vm.download}},[_vm._v("hier")]),_vm._v(". ")])}
var staticRenderFns = []

export { render, staticRenderFns }